import { inject } from '@angular/core';
import { CanActivateFn, NavigationEnd, Router } from '@angular/router';
import { notNull } from '@app/shared/utils';
import { AppActions } from '@app/store';
import { ActiveUser } from '@app/store/app.selectors';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { startsWith } from 'lodash';
import { filter, of, take } from 'rxjs';
import { TrailsService } from '../services';
import { PaisEnum } from '@app/core/models';

export const CourseGuard: CanActivateFn = () => {
  const trailsService = inject(TrailsService);
  const router = inject(Router);
  const store = inject(Store<AppState>);
  const urls = ['trilhas-de-aprendizagem', 'universidade-corporativa', 'ivca'];

  router.events.pipe(filter((router) => router instanceof NavigationEnd)).subscribe((finalRouter) => {
    const isUC = startsWith(finalRouter['url'], `/${urls[1]}`);
    trailsService.uc$.next(isUC);
    const isIVCA = startsWith(finalRouter['url'], `/${urls[2]}`);
    const hideHeader = startsWith(finalRouter['url'], `/${urls[2]}/cursos`);
    trailsService.ivca$.next(isIVCA);

    store.dispatch(AppActions.IVCAReducer({ ivca: hideHeader }));

    const url = finalRouter['url'].split('/');

    if (url?.length === 2 && urls.includes(url[1])) {
      if (isUC) {
        return router.navigate([urls[1], 'cursos']);
      }

      if (isIVCA) {
        return router.navigate([urls[2], 'cursos']);
      }

      store
        .select(ActiveUser)
        .pipe(notNull(), take(1))
        .subscribe(({ aluno_id, pais_id }) => {
          if (aluno_id) {
            router.navigate([urls[0], 'cursos']);
          } else if (pais_id != PaisEnum.Brasil) {
            router.navigate([urls[0], 'cursos']);
          } else {
            router.navigate([urls[0], 'vitrine']);
          }
        });
    }
  });
  return of(true);
};
